
//import * as React from "react";
import { useState, useEffect } from "react";
import {Routes, Route, Router, useNavigate } from "react-router-dom";
import Write from "./create/Write";
import Read from "./read/Read";
import GetUserDetails from "./read/GetUserDetails";
import GetDeviceDetails from "./read/GetDeviceDetails";
import CreateDevice from "./create/CreateDevice";
import SetRecoveryEmail from "./create/SetRecoveryEmail";
import SetRecoveryPhone from "./create/SetRecoveryPhone";
import CleanHungLicenses from "./create/CleanHungLicenses";
import CleanDuplicateLicenses from "./create/CleanDuplicateLicenses";
import XioSupportToolPage from "./pages/XioSupportToolPage";
import AtsgHomePage from "./pages/AtsgHomePage"
import SsoHomePage from "./pages/SsoHomePage"
import LandingPage from "./pages/LandingPage"
import DevOpsToolsPage from "./pages/DevOpsToolsPage"
import Layout from './Layout'; // Import Layout component
import NavBar from "./NavBar"; // Import the NavBar component
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal,MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import {RouteGuard} from "./RouteGuard"; // Import the RouteGuard component
import { groups } from "./msalConfig"; // Import group IDs

function App({pca}) {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();

  // Extract the user's groups from the ID token
  const userGroups = accounts[0]?.idTokenClaims?.groups || [];

  // Extract the user's name from the ID token claims
  const userName = accounts[0]?.name || "User";


  // Convert the user's name to initials (e.g., "John Doe" -> "JD")
  const userInitials = userName
    .split(" ")
    .map((name) => name[0])
    .join("")
    .toUpperCase();

  console.log("Username in Apps",userInitials);
  console.log("User Groups:", userGroups);
   // Check if the user belongs to any of the defined groups
  const isAuthorized = Object.values(groups).some((groupId) => userGroups.includes(groupId));
  console.log("Is Authorized:", isAuthorized);
  console.log("Is Authenticated:", isAuthenticated);

  const handleLogin = async () => {
    try {
      await instance.loginPopup({
        scopes: ["User.Read"], 
      });
      console.log("Login successful");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/atsg/home", // Navigate to SAAS tool home after logout
      });
      console.log("Logout successful");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    
    <ClientSideNavigation pca={pca}>
        <MsalProvider instance={pca}>
          <div>
            <PageContent />  
          </div>
        </MsalProvider>
    </ClientSideNavigation>

  );
}

function PageContent() {
  return (
    <Routes>
      {/* Public route - accessible without authentication */}
      <Route path="/" element={<Layout><LandingPage/></Layout>} />
      
      {/* DevOps Tools page - requires authentication and EsOps group */}
      <Route path="/devops-tools" element={
        <>
          <AuthenticatedTemplate>
            <RouteGuard requiredGroups={[groups.EsOps]}>
              <DevOpsToolsPage/>
            </RouteGuard>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Layout>
              <center><font size="5">Please click on the Login button to Sign In.</font></center>
            </Layout>
          </UnauthenticatedTemplate>
        </>
      } />
      
      {/* Tools page - requires authentication */}
      <Route path="/tools" element={
        <Layout>
          <AuthenticatedTemplate>
            <XioSupportToolPage/>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <center><font size="5">Please click on the Login button to Sign In.</font></center>
          </UnauthenticatedTemplate>
        </Layout>
      } />
      
      {/* All other protected routes */}
      <Route path="/atsg/*" element={
        <Layout>
          <AuthenticatedTemplate>
            <AuthenticatedPages />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <center><font size="5">Please click on the Login button to Sign In.</font></center>
          </UnauthenticatedTemplate>
        </Layout>
      } />
      
      <Route path="/sso/*" element={
        <Layout>
          <AuthenticatedTemplate>
            <AuthenticatedPages />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <center><font size="5">Please click on the Login button to Sign In.</font></center>
          </UnauthenticatedTemplate>
        </Layout>
      } />
    </Routes>
  )
}

function AuthenticatedPages() {
  return (
    <Routes>
      <Route path="home" element={<RouteGuard requiredGroups={[ groups.EsOps, groups.XioSupportToolsAtsgRW , groups.XioSupportToolsAtsgRO,groups.XioSupportToolsAtsgAdmin]}><AtsgHomePage /> </RouteGuard>} />
      <Route path="/sso/home" element={<RouteGuard requiredGroups={[ groups.DevOps_Automation_Users]}><SsoHomePage /> </RouteGuard>} />
      <Route path="write" element={<RouteGuard requiredGroups={[groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin]}> <Write /> </RouteGuard>} />
      <Route path="write/create_device" element={<RouteGuard requiredGroups={[ groups.XioSupportToolsAtsgAdmin]}> <CreateDevice /> </RouteGuard>} /> 
      <Route path="write/set_recov_email" element={<RouteGuard requiredGroups={[  groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin,groups.XioSupportToolsAtsgAdmin]}> <SetRecoveryEmail /> </RouteGuard>} />
      <Route path="write/set_recov_phone" element={<RouteGuard requiredGroups={[  groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin]}> <SetRecoveryPhone /> </RouteGuard>} />
      <Route path="read" element={<RouteGuard requiredGroups={[groups.XioSupportToolsAtsgRO,groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin]}> <Read /> </RouteGuard>} />
      <Route path="read/device_details" element={<RouteGuard requiredGroups={[ groups.XioSupportToolsAtsgRO,groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin]}> <GetDeviceDetails /> </RouteGuard>} />
      <Route path="read/user_details" element={<RouteGuard requiredGroups={[ groups.XioSupportToolsAtsgRO,groups.XioSupportToolsAtsgRW,groups.XioSupportToolsAtsgAdmin]}> <GetUserDetails /> </RouteGuard>} />
    </Routes>
  )
}


/**
 *  This component is optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
 */ 
function ClientSideNavigation({ pca, children }) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  // react-router-dom v6 doesn't allow navigation on the first render - delay rendering of MsalProvider to get around this limitation
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    setFirstRender(false);
  }, []);

  if (firstRender) {
    return null;
  }

  return children;
}


export default App;
